<script>
import _ from "lodash";

export default {
    name: "SessionTranscription",
    props: {
        session: {
            type: Object,
        },
        time: {
            type: Number,
        },
    },
    computed: {
        transcription() {
            return this.session?.transcription || {};
        },
    },
    watch: {
        transcription: {
            handler() {
                this.rewind(1000);
            },
            immediate: true,
        },
    },
    methods: {
        getPrettyTime(v) {
            return this.$moment.duration(v, 'seconds').format('hh:mm:ss', {trim: false});
        },
        getSegmentId(v) {
            return 'segment-'+v.id;
        },
        rewind(pause = 0) {
            const time = this.time,
                segment = time && _.find(this.transcription.segments, segment => segment.start_time <= time && time < segment.end_time),
                segmentId = segment && this.getSegmentId(segment);

            if (segmentId) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        document.querySelector('#' + segmentId)
                            .scrollIntoView({
                                behavior: 'smooth'
                            });
                    }, pause);
                });
            }
        },
    },
}
</script>

<template>
    <v-container>
        <v-row>
            <v-col>
                <v-timeline
                    align-top
                    dense
                    clipped
                >
                    <v-slide-x-transition
                        group
                    >
                        <v-timeline-item
                            v-for="segment in transcription.segments"
                            :key="segment.id"
                            class="mb-4 mr-4"
                            small
                        >
                            <v-row justify="space-between" :id="getSegmentId(segment)">
                                <v-col>
                                    <div class="comment-content">{{ segment.text }}</div>
                                    <div class="mt-2 grey--text text-body-2">
                                        <template v-if="segment.id_speaker">
                                            <template v-if="segment.name_ru">
                                                {{ segment.name_ru }},
                                            </template>
                                            <template v-else-if="segment.id_speaker > 0">
                                                Спикер #{{ segment.id_speaker }}, требуется синхронизация спикеров,
                                            </template>
                                            <template v-else>
                                                {{ segment.id_speaker }},
                                            </template>
                                        </template>
                                        {{ getPrettyTime(segment.start_time) }} - {{ getPrettyTime(segment.end_time) }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-timeline-item>
                    </v-slide-x-transition>
                </v-timeline>

            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped lang="scss">

</style>
